import { CognitoUtil } from './../authentication/cognito.service';
import { AppConfig } from './../app.config';
import { SurvivalHorizonService } from './../survival-horizon/survival-horizon.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    GetSurvivalHorizonServiceDataOutput,
    ProjectionMonitoringData
} from '@liquitics/transaction';
import { Correction, CORRECTION_TYPES } from '@liquitics/transaction';
import { UserProfile } from '@liquitics/transaction';

import { ProjectionUpdateComponent } from '../correction/projection-update/projection-update.component';
import { JWTService } from '../authentication/jwt.service';

@Component({
    selector: 'app-projection',
    templateUrl: './projection.component.html',
    styleUrls: ['./projection.component.css']
})
export class ProjectionComponent implements OnInit, OnDestroy {
    tableData: any = [];
    singleCurrency: boolean;
    currency: string;
    private dataStreamDisposable: Subscription;

    currentFirstShownRowIndex = 0;
    subscription: Subscription;
    showTable = false;

    constructor(private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig,
        private jwtService: JWTService,
        public dialog: MatDialog) {
        this.singleCurrency = this.appConfig.activeUserProfile.getCurrencies().length === 1;
    }

    ngOnInit() {
        this.dataStreamDisposable = this.survivalHorizonService.getPollingDataSubject()
            .subscribe({
                next: (data: GetSurvivalHorizonServiceDataOutput) => {
                    const dataAny: any = data;
                    this.updateTableData(dataAny.projectionsNew);
                }, error: (err) => {
                    console.log(err);
                    throw err;
                }
            });
        this.subscription = this.dashboardEventService.profileSubject.subscribe({
            next: (userProfile: UserProfile) => {
                this.singleCurrency = this.appConfig.activeUserProfile.getCurrencies().length === 1;
            }
        })
        this.subscription.add(this.dashboardEventService.currencySelectionSubject.subscribe({
            next: currency => {
                this.currency = currency;
                const currentRequest = this.survivalHorizonService.buildPollingRequestParams();
                this.showTable = false;
                this.survivalHorizonService.getDataObservable(currentRequest)
                    .pipe(take(1))
                    .toPromise()
                    .then((data: GetSurvivalHorizonServiceDataOutput) => {
                        const dataAny: any = data;
                        this.updateTableData(dataAny.projectionsNew);
                    })
            }
        }));
    }

    onPage(event) {
        this.currentFirstShownRowIndex = event.first;
    }

    private updateTableData(projectionMonitoringData: ProjectionMonitoringData[]) {
        if (projectionMonitoringData) {
            this.tableData = projectionMonitoringData
                .filter((pmd: ProjectionMonitoringData) => {
                    return pmd.type !== 'UNEXPECTED';
                })
                .map((pmd: ProjectionMonitoringData) => {
                    pmd.dataKey = pmd.currency + '.' + pmd.direction + '.' + pmd.targetName;
                    if (pmd.projectedAmount !== 0) {
                        pmd.completionPercentage = Math.abs(pmd.filledAmount / pmd.projectedAmount) * 100;
                    }
                    return pmd;
                })
                .sort((a1: ProjectionMonitoringData, a2: ProjectionMonitoringData) => {
                    const percentageDiff = Math.abs(a2.completionPercentage) - Math.abs(a1.completionPercentage);
                    if (percentageDiff === 0) {
                        return a2.projectedAmount - a1.projectedAmount;
                    }
                    return percentageDiff;
                    // return (Math.abs((100 - a2.completionPercentage) * a2.projectedAmount)
                    // - Math.abs((100 - a1.completionPercentage) * a1.projectedAmount));
                })
                // .slice(0, 11)
                // ;
                ;
            const holdOn = this.currentFirstShownRowIndex;
            this.currentFirstShownRowIndex = 0;
            this.currentFirstShownRowIndex = holdOn;
            setTimeout(() => {
                this.showTable = true;
            }, 1000);
        }
    }

    ngOnDestroy() {
        if (this.dataStreamDisposable) {
            this.dataStreamDisposable.unsubscribe();
        }
        this.subscription.unsubscribe();
    }

    onHistory(pmd: ProjectionMonitoringData) {
        this.dashboardEventService.projectionMonitoringDataSelectionSubject.next(pmd);
    }

    editProjection(pmd: ProjectionMonitoringData) {
        const correction = {} as Correction;
        correction.type = CORRECTION_TYPES.PROJECTION_UPDATE;
        correction.settleDate = this.appConfig.getTodayString();
        correction.direction = pmd.direction;
        correction.currency = pmd.currency;
        correction.projectionUpdateClientGroup = pmd.targetName;
        correction.username = this.jwtService.getUserCredentials().getUserName();
        correction.amount = 0;
        // correction.desk;
        // correction.changeReason;
        // correction.projectionUpdateProductType;

        const dialogRef = this.dialog.open(ProjectionUpdateComponent, {
            // width: '50%',
            data: {
                correction: correction
            }
        });

        dialogRef.afterClosed().subscribe({
            next: result => {
                // console.log('The dialog was closed');
            }
        });
    }

    addProjection() {
        const correction = {} as Correction;
        correction.type = CORRECTION_TYPES.PROJECTION_UPDATE;
        correction.settleDate = this.appConfig.getTodayString();
        correction.direction = 'PAY';
        correction.currency = this.currency || this.appConfig.activeUserProfile.getCurrencies()[0];
        // correction.projectionUpdateClientGroup = pmd.targetName;
        correction.username = this.jwtService.getUserCredentials().getUserName();
        correction.amount = 0;
        // correction.desk;
        // correction.changeReason;
        // correction.projectionUpdateProductType;

        const dialogRef = this.dialog.open(ProjectionUpdateComponent, {
            width: '50%',
            data: {
                correction: correction
            }
        });
    }
}
